import { Typography } from '@otp/ui';
import clsx from 'clsx';
import React from 'react';
import { getCategoryIcon } from 'src/components/notifications/utils/category-mapper';
import { GlobalEventType } from 'src/graphql/generated/graphql';

export const CategoryField = ({
  value,
  category,
  seen = false,
}: {
  value: string;
  category?: GlobalEventType;
  seen: boolean;
}) => {
  if (!category) {
    return value;
  }

  return (
    <div className={clsx('flex', 'items-center', 'gap-1')}>
      {getCategoryIcon(category)}
      <Typography variant="subtitle1" className={clsx({ 'font-bold': !seen })}>
        {value}
      </Typography>
    </div>
  );
};
